import { msg } from "@lingui/core/macro";
import {
  informationFieldConfigValueSchema,
  usePatientInformationFields,
  useProspectPatients,
} from "@/api/Patients";
import { PatientsTableContainer } from "./PatientsTableContainer";
import { useMemo } from "react";
import { getPatientFullName } from "@medoma/models/patients";
import { filterByNameTerms } from "@medoma/components/SearchField/searchUtils";
import { usePatientNameFilter } from "../PatientsContext";

export const ProspectPatients = () => {
  const { value: filter } = usePatientNameFilter();
  const { data: patients, isPending, isError, error } = useProspectPatients({});
  const { data: conditionalInformationFields } = usePatientInformationFields();

  const filteredPatients = useMemo(() => {
    if (!filter || !patients) {
      return patients;
    }

    return patients.filter((patient) =>
      filterByNameTerms(getPatientFullName(patient.name), filter),
    );
  }, [patients, filter]);

  const noResultsMessage =
    filteredPatients && patients && filteredPatients.length < patients.length
      ? msg`Det finns inga patienter under bedömning som matchar sökningen`
      : msg`Det finns inga patienter under bedömning`;

  const showPlannedAdmission =
    conditionalInformationFields?.PlannedAdmissionDateTime !==
    informationFieldConfigValueSchema.enum.hidden;

  return (
    <PatientsTableContainer
      patients={filteredPatients}
      isPending={isPending}
      isError={isError}
      error={error}
      additionalColumns={
        showPlannedAdmission ? ["plannedAdmissionDateTime"] : []
      }
      showNotifications={true}
      showPatientStatus={false}
      showPatientSignInStatus={false}
      showPrimaryResponsible={false}
      showPlaceOfAssessment={true}
      showPostDischargeProcessed={false}
      loadingMessage={msg`Hämtar patienter under bedömning`}
      errorMessage={msg`Kunde inte hämta patienter under bedömning`}
      noResultsMessage={noResultsMessage}
    />
  );
};
